import React from 'react';
import '../styles/Skeleton.css';

// Base skeleton element with shimmer animation
export const Skeleton = ({ width, height, borderRadius = '4px', className = '' }) => (
  <div
    className={`skeleton ${className}`}
    style={{
      width: width || '100%',
      height: height || '16px',
      borderRadius
    }}
  />
);

// Skeleton for list cards (MyLists, Discover, Following pages)
export const ListCardSkeleton = () => (
  <div className="list-card-skeleton">
    <div className="skeleton-hero" />
    <div className="skeleton-content">
      <Skeleton height="18px" width="70%" borderRadius="4px" />
      <Skeleton height="14px" width="50%" borderRadius="4px" />
      <Skeleton height="12px" width="30%" borderRadius="4px" />
      <div className="skeleton-meta">
        <Skeleton height="12px" width="80px" borderRadius="4px" />
        <Skeleton height="12px" width="60px" borderRadius="4px" />
      </div>
    </div>
  </div>
);

// Skeleton for place cards in ListDetail
export const PlaceCardSkeleton = () => (
  <div className="place-card-skeleton">
    <div className="skeleton-place-photo" />
    <div className="skeleton-place-content">
      <Skeleton height="16px" width="60%" borderRadius="4px" />
      <Skeleton height="13px" width="80%" borderRadius="4px" />
      <div className="skeleton-place-meta">
        <Skeleton height="12px" width="40px" borderRadius="4px" />
        <Skeleton height="12px" width="60px" borderRadius="4px" />
      </div>
    </div>
    <div className="skeleton-place-badge" />
  </div>
);

// Skeleton for user items (followers, friends, search results)
export const UserItemSkeleton = () => (
  <div className="user-item-skeleton">
    <div className="skeleton-avatar" />
    <div className="skeleton-user-info">
      <Skeleton height="15px" width="120px" borderRadius="4px" />
      <Skeleton height="13px" width="80px" borderRadius="4px" />
    </div>
  </div>
);

// Skeleton for notification items
export const NotificationSkeleton = () => (
  <div className="notification-skeleton">
    <div className="skeleton-avatar" />
    <div className="skeleton-notification-content">
      <Skeleton height="14px" width="90%" borderRadius="4px" />
      <Skeleton height="12px" width="60px" borderRadius="4px" />
    </div>
  </div>
);

// Skeleton for user profile header
export const ProfileHeaderSkeleton = () => (
  <div className="profile-header-skeleton">
    <div className="skeleton-profile-avatar" />
    <Skeleton height="22px" width="140px" borderRadius="4px" />
    <Skeleton height="14px" width="100px" borderRadius="4px" />
    <div className="skeleton-profile-stats">
      <div className="skeleton-stat">
        <Skeleton height="24px" width="30px" borderRadius="4px" />
        <Skeleton height="11px" width="40px" borderRadius="4px" />
      </div>
      <div className="skeleton-stat">
        <Skeleton height="24px" width="30px" borderRadius="4px" />
        <Skeleton height="11px" width="50px" borderRadius="4px" />
      </div>
      <div className="skeleton-stat">
        <Skeleton height="24px" width="30px" borderRadius="4px" />
        <Skeleton height="11px" width="45px" borderRadius="4px" />
      </div>
    </div>
  </div>
);

// Grid of list card skeletons
export const ListGridSkeleton = ({ count = 3 }) => (
  <div className="lists-grid">
    {Array.from({ length: count }).map((_, i) => (
      <ListCardSkeleton key={i} />
    ))}
  </div>
);

// List of place card skeletons
export const PlaceListSkeleton = ({ count = 4 }) => (
  <div className="place-list-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <PlaceCardSkeleton key={i} />
    ))}
  </div>
);

// List of user item skeletons
export const UserListSkeleton = ({ count = 5 }) => (
  <div className="user-list-skeleton">
    {Array.from({ length: count }).map((_, i) => (
      <UserItemSkeleton key={i} />
    ))}
  </div>
);

export default Skeleton;
